

const StyledButton = ({ btnText, btnEventHandler, customStyle,btnDisabled, children,cClassName='' }) => {

  return (
    <button disabled={btnDisabled} className={`${cClassName} bg-[#333333] text-white rounded-3xl px-2 py-1  w-[190px] hover:font-semibold inline-flex items-center justify-center  text-center 2xl:w-[270px] 2xl:h-[60px] 2xl:rounded-[30px] 2xl:text-[24px] 2xl:leading-[36px] 2xl:!font-500  ${customStyle}`} onClick={btnEventHandler}>
      {btnText.toUpperCase()}<span className="text-[1.4rem] mt-[2px]">{children}</span>
    </button>
  )
}

export default StyledButton